// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseApiServiceFactory instead of class inheritance

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";
import { FrontendVariables } from "@Front/Config/VariablesFront";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { logoutFromIdNotWithFetchImpl as logoutFromIdNotWithFetchImplHelper } from "./helpers/authLogoutHelpers";

import { getIdnotJwt } from "./helpers/authJwtHelpers";
import { loginWithIdNot, redirectToIdNotLogout } from "./helpers/authMethodsHelpers";

interface AuthInstance {
	redirectToIdNotLogout(): void;
	logoutFromIdNotWithFetch(): Promise<void>;
	logoutFromIdNotWithIframe(): Promise<void>;
	loginWithIdNot(): Promise<unknown>;
	getIdnotJwt(autorizationCode: string | string[], redirectUri?: string): Promise<{ accessToken: string; refreshToken: string }>;
}

// Module-level singleton instance
let instance: AuthInstance | null = null;
let baseApiInstance: IBaseApiService | null = null;


function createAuth(): AuthInstance {
	if (!baseApiInstance) {
		baseApiInstance = createBaseApiService();
	}

	const baseApi = baseApiInstance;

	const logoutFromIdNotWithFetchImpl = async (): Promise<void> => {
		const variables = FrontendVariables.getInstance();
		const baseUrl = variables.IDNOT_BASE_URL;
		return logoutFromIdNotWithFetchImplHelper(baseUrl);
	};

	const authInstance: AuthInstance = {
		redirectToIdNotLogout: (): void => {
			redirectToIdNotLogout();
		},
		logoutFromIdNotWithFetch: logoutFromIdNotWithFetchImpl,
		logoutFromIdNotWithIframe: async (): Promise<void> => {
			LoggerService.warn("⚠️ logoutFromIdNotWithIframe() est dépréciée, utilisation de logoutFromIdNotWithFetch()");
			return logoutFromIdNotWithFetchImpl();
		},
		loginWithIdNot: async (): Promise<unknown> => {
			return loginWithIdNot(baseApi);
		},
		getIdnotJwt: async (
			autorizationCode: string | string[],
			redirectUri?: string,
		): Promise<{ accessToken: string; refreshToken: string }> => {
			return getIdnotJwt(baseApi, autorizationCode, redirectUri);
		},
	};

	return authInstance;
}

export function getAuthInstance(): AuthInstance {
	if (!instance) {
		instance = createAuth();
	}
	return instance;
}
